import { SidebarMetaInfo } from "@/utils/getSidebarMetaInfo";
import {
  Breadcrumbs as BreadcrumbsMantine,
  Container,
  Flex,
  Group,
} from "@mantine/core";
import Link from "next/link";
import { PropsWithChildren } from "react";
import { Footer } from "@/features/Footer";
import { Header } from "@/features/Header";
import cx from "clsx";
import { useRouter } from "next/router";
import css from "./BlogLayout.module.css";
import { Sidebar } from "./Sidebar";

const getBreadcrumbsItems = (
  breadcrumb: BlogLayoutProps["breadcrumb"],
  path: string
) => {
  let items = [{ title: "Главная", href: "/" }];

  if (path.startsWith("/blog")) {
    items.push({ title: "Блог", href: "/blog" });
  }

  if (breadcrumb) {
    items.push(breadcrumb);
  }

  return items.map((item, index) => (
    <Link
      href={item.href}
      key={index}
      data-active={index === items.length - 1}
      prefetch={false}
    >
      {item.title}
    </Link>
  ));
};

interface BlogLayoutProps {
  breadcrumb?: { title: string; href: string };
  sidebarMetaInfo: SidebarMetaInfo | undefined;
  fullWidth?: boolean;
}

export const BlogLayout: React.FC<PropsWithChildren<BlogLayoutProps>> = ({
  children,
  breadcrumb,
  sidebarMetaInfo,
  fullWidth,
}) => {
  const router = useRouter();

  return (
    <Flex direction="column" justify="space-between" gap="30px">
      <Header />
      <main>
        <Container className={css.breadcrumbContainer}>
          <div className={css.innerContainer}>
            <Group justify="center">
              <BreadcrumbsMantine separator="»" className={css.link}>
                {getBreadcrumbsItems(breadcrumb, router.asPath)}
              </BreadcrumbsMantine>
            </Group>
          </div>
        </Container>

        <div
          className={cx(
            css.container,
            fullWidth ? css.oneColumn : css.gridWithSidebar
          )}
        >
          <section>{children}</section>

          <Sidebar sidebarMetaInfo={sidebarMetaInfo} />
        </div>
      </main>

      <Footer />
    </Flex>
  );
};
